import keycloakAxios from '@/services/axios';
import {GetAccountResponseBody} from '@/types/payments';

export const getAccount = async () => {
  const response = await keycloakAxios.get<GetAccountResponseBody>(
    'payments/account'
  );

  if (response.status >= 300) {
    throw new Error(
      `Error getting account: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
